import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Facility } from 'src/app/modules/entry-control/interfaces/facility';
import { TaskChecklist, TaskExecution } from 'src/app/modules/entry-control/interfaces/tasks';

@Component({
  selector: 'app-list-tasks-facility',
  templateUrl: './list-tasks-facility.component.html',
  styleUrls: ['./list-tasks-facility.component.css']
})
export class ListTasksFacilityComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }

  /** Instalación fija (uso dentro de la ficha de instalación). */
  @Input()
  facilityId: number = 0;

  /** false = pantalla global con selector de instalación (uso en Registro > Gestión). */
  @Input()
  lockFacility: boolean = true;

  active = 1;
  idSelected: number = 0;
  executionIdSelected: number | string = 0;

  checklists: TaskChecklist[] = [];
  executions: TaskExecution[] = [];
  facilityes: Facility[] = [];

  filterForm = new UntypedFormGroup({
    facility_id: new UntypedFormControl(0),
  });

  ngOnInit(): void {
    if (this.lockFacility) {
      if (this.facilityId > 0) {
        this.getChecklists();
        this.getExecutions();
      }
    } else {
      this.filterForm.get('facility_id')?.setValue(this.facilityId || 0);
      this.getFacilities();
      this.getChecklists();
      this.getExecutions();
    }
  }

  get currentFacilityId(): number {
    return this.lockFacility ? this.facilityId : Number(this.filterForm.get('facility_id')?.value || 0);
  }

  getFacilities() {
    this.api.getAllFacility().subscribe((res) => {
      this.facilityes = res.data as Facility[];
    });
  }

  getChecklists() {
    if (this.lockFacility) {
      this.api.getTaskChecklistsByFacility(this.facilityId).subscribe(
        (response) => {
          this.checklists = response.data as TaskChecklist[];
        },
        () => {
          this.checklists = [];
        }
      );
      return;
    }
    const facilityId = this.currentFacilityId;
    this.api.getAllTaskChecklists(facilityId > 0 ? facilityId : undefined).subscribe(
      (response) => {
        this.checklists = response.data as TaskChecklist[];
      },
      () => {
        this.checklists = [];
      }
    );
  }

  getExecutions() {
    if (this.lockFacility) {
      this.api.getTaskExecutionsByFacility(this.facilityId).subscribe(
        (response) => {
          this.executions = response.data as TaskExecution[];
        },
        () => {
          this.executions = [];
        }
      );
      return;
    }
    const facilityId = this.currentFacilityId;
    this.api.getAllTaskExecutions(facilityId > 0 ? { facility_id: facilityId } : undefined).subscribe(
      (response) => {
        this.executions = response.data as TaskExecution[];
      },
      () => {
        this.executions = [];
      }
    );
  }

  filterChange() {
    this.getChecklists();
    this.getExecutions();
  }

  openModal(md: any, size: string = 'lg') {
    this.modal.open(md, { size: size });
  }
  openEdit(id: number, md: any) {
    this.idSelected = id;
    this.modal.open(md, { size: 'lg' });
  }
  openView(id: number | string, md: any) {
    this.executionIdSelected = id;
    this.modal.open(md, { size: 'lg' });
  }
  toggleStatus(item: TaskChecklist) {
    const newStatus = !item.active;
    this.api.updateTaskChecklistStatus(item.id as number, newStatus).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Gestión de tareas');
        item.active = newStatus;
      },
      (error) => {
        this.toast.warning(error.error.mistakes, error.error.msg);
      }
    );
  }
}
